import i18n from "@/locale"
import { appStore } from "@/stores"

const { t } = i18n.global
// 企业人数
export const companyUserNumberOptions = [
  {
    value: '0-4',
    label: '<5 ',
  },
  {
    value: '5-20',
    label: '5-20',
  },
  {
    value: '21-50',
    label: '21-50',
  },
  {
    value: '51-100',
    label: '51-100',
  },
  {
    value: '101-200',
    label: '101-200',
  },
  {
    value: '201-500',
    label: '201-500',
  },
  {
    value: '501-1000',
    label: '501-1000',
  },
  {
    value: '1000-9999',
    label: '>1000',
  },
]
// 企业所在行业
export const companyIndustryOptions = [
  {
    value: 'Accommodation and Food Services',
    label: t('Accommodation and Food Services'),
  },
  {
    value: 'Administration, Business Support, and Waste Management Services',
    label: t('Administration, Business Support, and Waste Management Services'),
  },
  {
    value: 'Agriculture, Forestry, Fishing, and Hunting',
    label: t('Agriculture, Forestry, Fishing, and Hunting'),
  },
  {
    value: 'Arts, Entertainment, and Recreation',
    label: t('Arts, Entertainment, and Recreation'),
  },
  {
    value: 'Construction',
    label: t('Construction'),
  },
  {
    value: 'Educational Services',
    label: t('Educational Services'),
  },
  {
    value: 'Finance and Insurance',
    label: t('Finance and Insurance'),
  },
  {
    value: 'Healthcare and Social Assistance',
    label: t('Healthcare and Social Assistance'),
  },
  {
    value: 'Information and Communication',
    label: t('Information and Communication'),
  },
  {
    value: 'Manufacturing',
    label: t('Manufacturing'),
  },
  {
    value: 'Mining',
    label: t('Mining'),
  },
  {
    value: 'Professional, Scientific, and Technical Services',
    label: t('Professional, Scientific, and Technical Services'),
  },
  {
    value: 'Real Estate, Rental, and Leasing',
    label: t('Real Estate, Rental, and Leasing'),
  },
  {
    value: 'Wholesale and Retail Trade',
    label: t('Wholesale and Retail Trade'),
  },
  {
    value: 'Transportation and Warehousing',
    label: t('Transportation and Warehousing'),
  },
  {
    value: 'Utilities',
    label: t('Utilities'),
  },
  {
    value: 'Other Services',
    label: t('Other Services'),
  },
]
// 用户职业
export const userWorkOptions = [
  // 前几项海外和国内显示的不一样
  ...(appStore.isCN ? [
    {
      value: '本科在读',
      label: t('本科在读'),
    },
    {
      value: '硕士在读',
      label: t('硕士在读'),
    },
    {
      value: '博士在读',
      label: t('博士在读'),
    },
    {
      value: '教师',
      label: t('教师'),
    },
    {
      value: '医疗健康',
      label: t('医疗健康'),
    },
    {
      value: 'IT',
      label: t('IT'),
    },
    {
      value: '金融/证券从业者',
      label: t('金融/证券从业者'),
    },
    {
      value: '法律行业',
      label: t('法律行业'),
    },
    {
      value: '财务/审计人员',
      label: t('财务/审计人员'),
    },
    {
      value: '工程行业',
      label: t('工程行业'),
    },
    {
      value: '政府和公共服务',
      label: t('政府和公共服务'),
    },
    {
      value: '非营利组织和非政府组织',
      label: t('非营利组织和非政府组织'),
    },
    {
      value: '数据分析师',
      label: t('数据分析师'),
    },
    {
      value: '市场/公关人员',
      label: t('市场/公关人员'),
    },
    {
      value: '能源和公用事业',
      label: t('能源和公用事业'),
    },
    {
      value: '制造业',
      label: t('制造业'),
    },
    {
      value: '房地产',
      label: t('房地产'),
    },
    {
      value: '人力资源',
      label: t('人力资源'),
    },
    {
      value: '顾问/咨询',
      label: t('顾问/咨询'),
    },
    {
      value: '建筑及施工',
      label: t('建筑及施工'),
    },
    {
      value: '其他',
      label: t('其他'),
    }
  ] : [
    {
      value: 'Education (students or education Staff)',
      label: t('Education (students or education Staff)'),
    },
    {
      value: 'Healthcare',
      label: t('Healthcare'),
    },
    {
      value: 'IT',
      label: t('IT'),
    },
    {
      value: 'Finance',
      label: t('Finance'),
    },
    {
      value: 'Legal',
      label: t('Legal'),
    },
    {
      value: 'Creative industries',
      label: t('Creative industries'),
    },
    {
      value: 'Engineering',
      label: t('Engineering'),
    },
    {
      value: 'Goverment and public service',
      label: t('Goverment and public service'),
    },
    {
      value: 'Non-profit and NGOs',
      label: t('Non-profit and NGOs'),
    },
    {
      value: 'Media and entertainment',
      label: t('Media and entertainment'),
    },
    {
      value: 'Marketing and advertising',
      label: t('Marketing and advertising'),
    },
    {
      value: 'Energy and utilities',
      label: t('Energy and utilities'),
    },
    {
      value: 'Manufacturing',
      label: t('Manufacturing_1'),
    },
    {
      value: 'Real estate',
      label: t('Real estate'),
    },
    {
      value: 'Human resource',
      label: t('Human resource'),
    },
    {
      value: 'Telecommunication',
      label: t('Telecommunication'),
    },
    {
      value: 'Consulting',
      label: t('Consulting'),
    },
    {
      value: 'Building and construction',
      label: t('Building and construction'),
    },
    {
      value: 'Retired',
      label: t('Retired'),
    },
    {
      value: 'Others',
      label: t('Others'),
    },
  ])
]
// 用户年龄
export const userAgeOptions = [
  {
    value: '0_18',
    label: t('Under 18'),
  },
  {
    value: appStore.isCN ? '18_22' : '18_24',
    label: t('18-24'),
  },
  {
    value: appStore.isCN ? '23_26' : '25_34',
    label: t('25-34'),
  },
  {
    value: appStore.isCN ? '27_30' : '35_44',
    label: t('35-44'),
  },
  {
    value: appStore.isCN ? '31_40' : '45_54',
    label: t('45-54'),
  },
  {
    value: appStore.isCN ? '40_50' : '55_64',
    label: t('55-64'),
  },
  {
    value: appStore.isCN ? '50_100' : '65_100',
    label: t('65 and over'),
  },
  {
    value: '-1_-1',
    label: t('I prefer not to say'),
  },
]
// 用途
export const whereToUseOptions = [
  {
    value: !appStore.isCN ? 'For personal use' : '个人使用',
    label: t('For personal use'),
  },
  {
    value: !appStore.isCN ? 'For work' : '工作使用',
    label: t('For work'),
  },
  {
    value: !appStore.isCN ? 'For my study or education work' : '学习或教育工作',
    label: t('For my study or education work'),
  },
]
// 从何处听说
export const whereToKnownOptions = [
  ...(appStore.isCN ? [
    {
      value: '搜索 (百度、 必应、谷歌等)',
      label: t('搜索 (百度、 必应、谷歌等)'),
    },
    {
      value: '知乎',
      label: t('知乎'),
    },
    {
      value: '小红书',
      label: t('小红书'),
    },
    {
      value: 'B站',
      label: t('B站'),
    },
    {
      value: '抖音',
      label: t('抖音'),
    },
    {
      value: '其他社交平台(今日头条、视频号、公众号等)',
      label: t('其他社交平台(今日头条、视频号、公众号等)'),
    },
    {
      value: '来自同学和朋友的推荐',
      label: t('来自同学和朋友的推荐'),
    },
    {
      value: '其他',
      label: t('其他(请说明)'),
    },
  ] : [{
    value: 'Search (Google, Bing, etc.)',
    label: t('Search (Google, Bing, etc.)'),
  },
  {
    value: 'Internet(newsletter, publication, blog etc.)',
    label: t('Internet(newsletter, publication, blog etc.)'),
  },
  {
    value: 'Internet ads',
    label: t('Internet ads'),
  },
  {
    value: 'Youtube',
    label: t('Youtube'),
  },
  {
    value: 'Tiktok',
    label: t('Tiktok'),
  },
  {
    value: 'Social media(Linkedin, Facebook, X, instagram etc.)',
    label: t('Social media(Linkedin, Facebook, X, instagram etc.)'),
  },
  {
    value: 'From a friend or colleague',
    label: t('From a friend or colleague'),
  },
  {
    value: 'Others',
    label: t('Others(please specify)'),
  }])
]
// 使用哪些功能
export const whatFeaturesToUseOptions = [
  {
    value: !appStore.isCN ? 'AI' : 'AI',
    label: t('AI'),
  },
  {
    value: !appStore.isCN ? 'Edit PDF' : '编辑 PDF',
    label: t('Edit PDF'),
  },
  {
    value: !appStore.isCN ? 'Annotate PDF' : '注释 PDF',
    label: t('Annotate PDF'),
  },
  {
    value: !appStore.isCN ? 'Convert PDF' : '转换 PDF',
    label: t('Convert PDF'),
  },
  {
    value: !appStore.isCN ? 'OCR' : 'OCR',
    label: t('OCR'),
  },
  {
    value: !appStore.isCN ? 'Create, fill and sign PDFs' : '创建, 填写和签名PDF文件',
    label: t('Create, fill and sign PDFs'),
  },
  {
    value: !appStore.isCN ? 'Organize PDF pages' : '组织 PDF 页面',
    label: t('Organize PDF pages'),
  },
  {
    value: !appStore.isCN ? 'Redact and protect PDFs' : '云同步',
    label: t('Redact and protect PDFs'),
  },
  {
    value: !appStore.isCN ? 'I don\'t know yet' : '我不知道',
    label: t('I don\'t know yet'),
  },
]